<script>
  import _ from 'lodash';

  export default {
    data() {
      return {
        condition: null,
        worker_comment: '',
        new_asin: {
          asin: null,
        },
        isNewAsinValid: null,
        isAsinChecking: false,
        quantity: 1,
        validators: {
          quantity: {
            valid: true,
            regexp: 10000,
            validator: 'quantity',
          },
        },
      };
    },
    computed: {
      isButtonActive() {
        if (this.condition === null) return false;

        if (this.new_asin.asin && !this.isNewAsinValid) return false;

        const invalids = Object.keys(this.validators)
          .filter((key) => this.validators[key].valid === false).length;

        return invalids === 0;
      },
    },
    props: ['modal_asin'],
    methods: {
      isValid() {
        Object.keys(this.validators).forEach((key) => {
          const validator = this.validators[key];
          validator.valid = this.validate(validator.validator);
        });

        return Object.keys(this.validators)
          .filter((key) => this.validators[key].valid === true).length !== 0;
      },
      validate(value) {
        this.validators.quantity.valid = value > 0 && value <= this.modal_asin.product.quantity;
      },
      save() {
        const data = {
          order_id: this.modal_asin.order_id,
          data: {
            product_id: this.modal_asin.product.product_id,
            condition: Number(this.condition),
            quantity: Number(this.quantity),
            worker_comment: this.worker_comment,
            new_asin: this.new_asin.asin,
          },
        };

        this.$store.dispatch('ib_set_condition', data);
      },
      close(event) {
        if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
          this.$store.commit('set_instock_modal_asin', null);
        }
      },
      checkNewAsin(value) {
        this.isAsinChecking = true;
        this.$store.dispatch('getASINInfo', value)
          .then((data) => {
            this.new_asin = {
              image: data.image,
              title: data.title,
              asin: data.asin,
            };
            this.isNewAsinValid = data.asin === this.new_asin.asin;
          })
          .catch((error) => {
            this.isNewAsinValid = false;
            console.error('Error:', error);
          })
          .finally(() => {
            this.isAsinChecking = false;
          });
      },
      changeAsin(value) {
        if (!value || !/^[A-Z0-9]{10}$/.test(this.new_asin.asin)) {
          this.isNewAsinValid = null;
          return;
        }
        _.debounce(() => this.checkNewAsin(this.new_asin.asin), 30, false)();
      },
    },
  };
</script>
<template src="./set_condition.pug" lang="pug"></template>
